import React, { useEffect, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";

const ProfessionalTaxRegistration = () => {

  
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    document.title = "Professional Tax Registration Service | PT Registration India";

    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content =
      "Apply for Professional Tax Registration online with expert assistance. Fast PT registration for employers, businesses, and professionals in India.";
    document.head.appendChild(meta);
  }, []);

  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>Professional Tax Registration Service</h1>
        <p>State-Level Tax Compliance for Businesses & Professionals</p>
      <button className="hero-btn" onClick={scrollToContact} >
          Get Started Today
        </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Professional Tax (PT) is a state-level tax levied on individuals earning income through salary,
          profession, trade, or employment. Employers must register and deduct PT from employees’ salaries
          where applicable.
        </p>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs Professional Tax Registration?</h2>
        <div className="card">Private Limited Companies</div>
        <div className="card">LLPs & Partnership Firms</div>
        <div className="card">Proprietorship Businesses</div>
        <div className="card">Employers with salaried employees</div>
        <div className="card">Self-employed professionals</div>
        <p style={{marginTop: "10px", color: "gray"}}>
          Note: PT rules and rates vary from state to state.
        </p>
      </section>

      {/* TYPES */}
      <section className="service-section">
        <h2>Types of Professional Tax Registration</h2>

        <div className="card">
          <strong>Employer Registration</strong>
          <p>For businesses deducting PT from employees and depositing it with the government.</p>
        </div>

        <div className="card">
          <strong>Professional Enrollment</strong>
          <p>For self-employed individuals paying PT directly as per applicable slabs.</p>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Professional Tax Registration</h2>
        <ul>
          <li>✔ Legal compliance with state laws</li>
          <li>✔ Avoid penalties and notices</li>
          <li>✔ Smooth payroll processing</li>
          <li>✔ Proper salary structuring</li>
          <li>✔ Increased business credibility</li>
        </ul>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our Professional Tax Services</h2>
        <ul>
          <li>Eligibility check based on state rules</li>
          <li>Online PT registration filing</li>
          <li>Documentation support & verification</li>
          <li>PT Registration Certificate assistance</li>
          <li>Monthly/annual return filing guidance</li>
          <li>Employer compliance support</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <div className="card">PAN Card</div>
        <div className="card">Aadhaar Card</div>
        <div className="card">Business Registration Certificate</div>
        <div className="card">Address Proof</div>
        <div className="card">Employee Details</div>
        <div className="card">Salary Structure Details</div>
        <div className="card">Bank Account Details</div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Professional Tax Registration Process</h2>
        <ul>
          <li>Consultation based on state applicability</li>
          <li>Document collection</li>
          <li>Online application submission</li>
          <li>Verification by state authority</li>
          <li>Certificate issuance</li>
        </ul>
      </section>

      {/* WHY US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ State-wise compliance expertise</li>
          <li>✔ Fast & error-free process</li>
          <li>✔ Complete documentation support</li>
          <li>✔ Affordable pricing</li>
          <li>✔ End-to-end assistance</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Get Professional Tax Registration Today</h2>
        <p>Stay compliant with state tax regulations easily.</p>
        <button>Apply Now</button>
      </section> */}


      
         <div className="cta" ref={contactRef}>
              <h2>Get Professional Tax Registration Today</h2>
              <p>Stay compliant with state tax regulations easily.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default ProfessionalTaxRegistration;